import Boom from 'boom'
import get from 'lodash/get'
import isArray from 'lodash/isArray'
import toLower from 'lodash/toLower'
import { create as createApi } from 'apisauce'

const url = process.env.REACT_APP_WEB_API || 'http://localhost:3030/api'

const makeApi = ({ token } = {}) => {
  const headers = {}

  if (token) {
    headers['Authorization'] = `Bearer ${token}`
  }

  const api = createApi({
    baseURL: url,
    headers,
    timeout: 20000,
  })

  const create = async (path, { data }) => {
    const response = await api.post(path, data)

    return handleResponse(response)
  }

  const update = async (path, { id, data }) => {
    const response = await api.patch(`${path}/${id}`, data)

    return handleResponse(response)
  }

  const getList = async (path, options = {}) => {
    const { filter = {}, pagination = {}, sort = {} } = options
    const { page = 1, perPage = 10 } = pagination
    const { field, order } = sort

    const query = {
      $limit: perPage,
      $skip: (page - 1) * perPage,
      ...filter,
    }

    if (field) {
      query.$sort = {
        [field]: toLower(order) === 'desc' ? '-1' : '1',
      }
    }

    const response = await api.get(path, query)

    return handleResponse(response)
  }

  const getOne = async (path, { id }) => {
    const response = await api.get(`${path}/${id}`)

    return handleResponse(response)
  }

  const deleteOne = async (path, { id }) => {
    const response = await api.delete(`${path}/${id}`)

    return handleResponse(response)
  }

  const validateResponse = (response) => {
    if (!response.ok) {
      if (response.status === 401) {
        throw Boom.unauthorized()
      } else if (response.status === 403) {
        throw Boom.forbidden('forbidden', response.data)
      } else if (response.status === 404) {
        throw Boom.notFound('Entity not found')
      } else if (response.status === 422) {
        throw Boom.notFound('Form data incorrect', { details: response.data.details })
      }

      const error = Boom.badGateway('Request failed to finish', {
        ...get(response, 'data.response', response),
      })

      throw error
    }
  }

  const handleResponse = (response) => {
    validateResponse(response)

    const data = response.data.data

    if (isArray(data)) {
      return {
        data,
        skip: get(response, 'data.skip'),
        limit: get(response, 'data.limit'),
        total: get(response, 'data.total', data.length),
      }
    }

    return data
  }

  return {
    api,
    validateResponse,
    getList,
    getOne,
    create,
    update,
    delete: deleteOne,
  }
}

export default makeApi
